import React, { useState, useEffect, useCallback } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { useDrawer } from '../../components/DrawerContext.jsx';
import Drawer from "react-modern-drawer";
import {FaPenToSquare, FaUserPen, FaUserPlus, FaCheck, FaX,} from "react-icons/fa6";
import CustomerForm from "./CustomerForm.jsx";
import { AddCircleOutline, Refresh as RefreshIcon } from "@mui/icons-material";
import { useAuth } from '../login/AuthContext';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';

import {
  Grid,
  Paper,
  Typography,
  Tabs,
  Tab,
  Box,
  Divider,
  Chip,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableContainer,
  CircularProgress,
  Button,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  IconButton,
  useMediaQuery,
  useTheme,
  Card,
  CardContent,
  Stack,
  Collapse,
} from "@mui/material";
import {
  Email,
  Phone,
  LocationOn,
  Business,
  Inventory,
  Description,
  ShoppingCart,
  Key,
  ExpandMore,
  KeyboardArrowDown,
  KeyboardArrowUp,
  Headset,
  Restaurant,
} from "@mui/icons-material";
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import DeleteFileDialog from './DeleteFileDialog';
import { toast } from "react-toastify";
import config from "../../config/config";
import Loading from "../../components/Loading/Loading.jsx";
import LicenseActions from "./CustomerDetailsUtils/LicenseActions.jsx";
import { handleCopyLicenseInfo } from "./CustomerDetailsUtils/handleCopyLicenseInfo.js";
import { formatDate, formatFileSize, getFileIcon, getStatusColor, getLisansDurumLabel } from "./CustomerDetailsUtils/CustomerDetailsUtils.jsx";
import {
  handleCertificateGenerate,
  gastoraModulesDisplay,
  erpEkModulesDisplay,
} from "./CustomerDetailsUtils/handleCertificateGenerate.js";

const CustomerDetails = () => {
  const { userData, token} = useAuth();
  const navigate = useNavigate();
  const { id } = useParams();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const [customer, setCustomer] = useState(null);
  const [programs, setPrograms] = useState(null);
  const [orders, setOrders] = useState([]);
  const [customerLicenses, setCustomerLicenses] = useState([]);
  const [gastoraLicenses, setGastoraLicenses] = useState([]);
  const [customerPackage, setCustomerPackage] = useState({});
  const [customerEkModule, setCustomerEkModule] = useState([]);
  const [customerSupports, setCustomerSupports] = useState([]);
  const [error, setError] = useState(null);
  const [activeTab, setActiveTab] = useState("siparisler");
  const [loading, setLoading] = useState(true);
  const { openDrawerWithCustomer } = useDrawer();
  const {
    isDrawerOpen,
    toggleDrawer,
    editingCustomer,
  } = useDrawer();

  const [customerFiles, setCustomerFiles] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [expanded, setExpanded] = useState(true);
  const [downloadingFiles, setDownloadingFiles] = useState([]);
  const [showCustomerInfo, setShowCustomerInfo] = useState(false);

  const MAX_FILE_SIZE_MB = 10;

  // Modern Tema Renkleri
  const modernTheme = {
    primary: "#1C355E",
    primaryLight: "#E8EAF6",
    accent: "#00A7B5",
    accentHover: "#008B98",
    success: "#10B981",
    warning: "#F59E0B",
    error: "#EF4444",
    text: {
      primary: "#1F2937",
      secondary: "#6B7280",
      light: "#9CA3AF",
    },
    background: {
      main: "#F9FAFB",
      // main: "color-mix(in srgb, rgb(255, 255, 255) 98%, rgb(24, 29, 31))",
      white: "#FFFFFF",
      paper: "#FFFFFF",
    },
    border: "#E5E7EB",
    borderLight: "#F3F4F6",
  };

  // Saat formatını düzelt (sadece saat göster)
  const formatTimeOnly = (timeValue) => {
    if (!timeValue) return "-";
    
    // Eğer string ise ve ISO formatında ise
    if (typeof timeValue === 'string') {
      // ISO formatı: 1970-01-01T15:00:00.000Z veya benzeri
      if (timeValue.includes('T') && timeValue.includes('Z')) {
        const date = new Date(timeValue);
        return date.toLocaleTimeString('tr-TR', { hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false });
      }
      // Eğer zaten HH:mm:ss formatında ise
      if (timeValue.includes(':')) {
        const parts = timeValue.split(':');
        if (parts.length >= 2) {
          return `${parts[0]}:${parts[1]}`;
        }
        return timeValue;
      }
      return timeValue;
    }
    
    // Eğer Date objesi ise
    if (timeValue instanceof Date) {
      return timeValue.toLocaleTimeString('tr-TR', { hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false });
    }
    
    return "-";
  };

  const handleRenewLicense = async (license) => {
    const ok = window.confirm(
      "Bu lisans boşta bırakılacak (cihaz kilidi kalkacak). Bitiş tarihi uzatılmaz. SimZET-VegaService ve Zet Hizmeti yeniden başlatılır. Devam edilsin mi?",
    );
    if (!ok) return;
    try {
      const response = await axios.put(`${config.baseURL}/lisanslar/lisans-yenile/${license.Id}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        }
      );

      if (response.status === 200) {
        toast.success(
          response.data?.message ||
            "Lisans boşta durumuna alındı. Yenileme talebi oluşturup onaylayın.",
        );
        fetchCustomerLicenses(customer.Id, token);
      } else {
        toast.error("Lisans yenileme işlemi başarısız oldu.");
      }
    } catch (error) {
      console.error("Lisans yenileme hatası:", error);
      toast.error(error.response?.data?.message || "Lisans yenileme işlemi başarısız oldu.");
    }
  };

  const isBayiFullAccess = Number(userData?.BayiId ?? userData?.BayiKodu ?? 0) === 1;

  const handleMusteriLisansPasifeAl = async (lisansId) => {
    if (!isBayiFullAccess || !customer?.Id) return;
    try {
      await axios.put(
        `${config.baseURL}/lisanslar/musteri-lisans-pasife-al/${lisansId}`,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      );
      toast.success("Lisans pasife alındı; bitiş tarihi bugüne çekildi. Tekrar kullanım için yeni sipariş gerekir.");
      fetchCustomerLicenses(customer.Id, token);
    } catch (e) {
      toast.error(e?.response?.data?.message || "Lisans pasife alınamadı.");
    }
  };

  const handleGastoraLisansEtkin = async (lisansId, etkin) => {
    if (!customer?.Id) return;
    try {
      await axios.patch(
        `${config.baseURL}/gastora-lisanslar/${lisansId}/etkin`,
        { Etkin: etkin },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      toast.success(etkin ? "Gastro lisansı aktif edildi." : "Gastro lisansı pasife alındı.");
      fetchGastoraLicenses(customer.Id, token);
    } catch (e) {
      toast.error(e?.response?.data?.message || "Lisans durumu güncellenemedi.");
    }
  };

  const handleRenewGastoraLicense = () => {
    navigate("/gastora/lisanslar/lisans-talep");
  };

  const handleGastoraTokenRenew = async (lisansId) => {
    if (!customer?.Id) return;
    try {
      const res = await axios.put(
        `${config.baseURL}/gastora-lisanslar/${lisansId}/token-yenile`,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      );
      toast.success("QR Menü token yenilendi.");
      if (res.data?.CloudQrToken) {
        await navigator.clipboard.writeText(res.data.CloudQrToken);
        toast.info("Token panoya kopyalandı.");
      }
      fetchGastoraLicenses(customer.Id, token);
    } catch (e) {
      toast.error(e?.response?.data?.message || "Token yenilenemedi.");
    }
  };

  const gastoraLicenseActions = (gl) => (
    <LicenseActions
      lisans={gl}
      onRenewLicense={handleRenewGastoraLicense}
      onCopyLicenseInfo={() => handleCopyLicenseInfo(gl, customer)}
      onCertificateGenerate={() => openLicenseCertificate(gl)}
      onPasifeAl={(lisansId) => handleGastoraLisansEtkin(lisansId, false)}
      onAktifeAl={(lisansId) => handleGastoraLisansEtkin(lisansId, true)}
      onTokenRenew={handleGastoraTokenRenew}
      isBayiFullAccess={isBayiFullAccess}
    />
  );

  const gastoraDurumChip = (gl) => {
    const label = gl.DurumLabel || (gl.SuresiDoldu ? "Süresi Doldu" : gl.AktifMi ? "Aktif" : "Pasif");
    const color = label === "Aktif" ? "success" : label === "Süresi Doldu" ? "error" : "default";
    return <Chip size="small" label={label} color={color} />;
  };

  useEffect(() => {
    if (!id) return;
    // Sayfa yenilemede Auth henüz hazır olmayabilir; hazır olunca tekrar çalışır
    if (!token || !userData) {
      return;
    }

    let cancelled = false;
    setLoading(true);
    setError(null);

    const fetchCustomer = async () => {
      try {
        const response = await fetch(`${config.baseURL}/musteriler/${id}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        if (!response.ok) {
          if (!cancelled) navigate("/404", { replace: true });
          return;
        }
        const data = await response.json();
        if (cancelled) return;

        setCustomer(data);
        await Promise.allSettled([
          fetchMusteriOrders(data.MusteriNo, token),
          fetchCustomerLicenses(data.Id, token),
          fetchGastoraLicenses(data.Id, token),
          fetchProgramToCustomer(data.Id, token),
          fetchCustomerPackage(data.Id, token),
          fetchCustomerEkModule(data.Id, token),
          fetchCustomerFiles(data.Id, token),
          fetchCustomerSupports(data.Id, token),
        ]);
      } catch (err) {
        if (cancelled) return;
        setError(err.message);
        toast.error(err.message);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    fetchCustomer();
    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, token, userData]);

  const fetchProgramToCustomer = async (id, token) => {
    try {
      const response = await fetch(`${config.baseURL}/musteriler/programlar/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (!response.ok) {
        throw new Error("Program bilgisi alınamadı");
      }
      const data = await response.json();
      setPrograms(Array.isArray(data) ? data : []);
    } catch (err) {
      console.error(err);
      setPrograms([]);
    }
  };

  const fetchMusteriOrders = async (musteriNo, token) => {
    try {
      const response = await fetch(`${config.baseURL}/siparis/musteri/${musteriNo}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        throw new Error("Siparişler alınamadı");
      }

      const orders = await response.json();
      const orderList = Array.isArray(orders) ? orders : [];

      const detailedOrders = await Promise.all(
        orderList.map(async (order) => {
          try {
            const detailResponse = await fetch(`${config.baseURL}/siparis/${order.Id}`, {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            });

            if (!detailResponse.ok) {
              throw new Error(`Sipariş detayı alınamadı: ${order.id}`);
            }

            const detailData = await detailResponse.json();

            return {
              ...order,
              details: detailData,
            };
          } catch (err) {
            console.error(`Sipariş ${order.Id} detayı alınırken hata:`, err.message);
            return { ...order, details: null };
          }
        })
      );

      setOrders(detailedOrders);
    } catch (err) {
      toast.error("Siparişler yüklenirken hata oluştu: " + err.message);
    } finally {
      setLoading(false);
    }
  };

  const fetchCustomerLicenses = async (customerId, token) => {
    try {
      const response = await fetch(`${config.baseURL}/lisanslar/musteri-lisans/${customerId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        throw new Error("Müşteri lisans bilgisi alınamadı");
      }

      const data = await response.json();
      setCustomerLicenses(Array.isArray(data) ? data : []);
    } catch (err) {
      console.error(err);
      setCustomerLicenses([]);
      toast.error(err.message);
    }
  };

  const fetchGastoraLicenses = async (customerId, token) => {
    try {
      const response = await fetch(`${config.baseURL}/gastora-lisanslar/musteri-lisans/${customerId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (!response.ok) {
        setGastoraLicenses([]);
        return;
      }
      const data = await response.json();
      setGastoraLicenses(Array.isArray(data) ? data : []);
    } catch (err) {
      console.error(err);
      setGastoraLicenses([]);
    }
  };

  const fetchCustomerPackage = async (customerId, token) => {
    try {
      const response = await fetch(`${config.baseURL}/musteriler/paket/${customerId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        throw new Error("Müşteri paket bilgisi alınamadı");
      }

      const data = await response.json();
      setCustomerPackage(data && typeof data === "object" ? data : {});
    } catch (err) {
      console.error(err);
      setCustomerPackage({});
    }
  }

  const fetchCustomerEkModule = async (customerId, token) => {
    try {
      const response = await fetch(`${config.baseURL}/musteriler/ekmodule/${customerId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        throw new Error("Müşteri ekmodul bilgisi alınamadı");
      }

      const data = await response.json();
      setCustomerEkModule(Array.isArray(data) ? data : []);
    } catch (err) {
      console.error(err);
      setCustomerEkModule([]);
    }
  }

  const fetchCustomerFiles = async (customerId, token) => {
    try {
      const response = await fetch(`${config.baseURL}/musteriler/musteri-dokuman/${customerId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        throw new Error("Müşteri doküman bilgisi alınamadı");
      }

      const data = await response.json();

      const files = data?.map((doc) => ({
        dokumanId: doc.Id,
        name: doc.DosyaAdi,
        systemName: doc.SistemDosyaAdi,
        IslemId:doc.IslemId,
        IslemTipi: doc.IslemTipi === 1 ? "Sipariş" : doc.IslemTipi === 2 ? "Lisans Yenileme": doc.IslemTipi === 0 ? "Müşteri Döküman" : "Bilinmiyor",
        Silinebilir: doc.IslemTipi === 1 ? false : doc.IslemTipi === 2 ? false : true,
        url: `${config.baseURL}/docs/${doc.SistemDosyaAdi}`,
        type: `application/${doc.DosyaAdi.split(".").pop()}`,
        size: doc.DosyaBoyutu,
        icon: getFileIcon(`application/${doc.DosyaAdi.split(".").pop()}`),
      }));

      setCustomerFiles(files || []);
      setLoading(false);
    } catch (err) {
      setError(err.message);
      toast.error(err.message);
      setLoading(false);
    }
  };

  const fetchCustomerSupports = async (customerId, token) => {
    try {
      const response = await fetch(`${config.baseURL}/destek/musteri/${customerId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        throw new Error("Destek bilgileri alınamadı");
      }

      const data = await response.json();
      setCustomerSupports(data?.data || []);
    } catch (err) {
      console.error("Destek bilgileri yüklenemedi:", err);
      setCustomerSupports([]);
    }
  };

  const handleCustomerCreated = (newCustomer) => {
    setCustomer((prevCustomer) => {
      if (prevCustomer && prevCustomer.Id === newCustomer.Id) {
        return { ...prevCustomer, ...newCustomer };
      }
      return prevCustomer;
    });

    toggleDrawer();
  };

  const handleEdit = async () => {
    if (!userData) {
      toast.error("Yetkilendirme hatası: Token bulunamadı.");
      return;
    }

    try {
      const response = await axios.get(`${config.baseURL}/musteriler/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      openDrawerWithCustomer(response.data, `/musteriler/${id}`);
    } catch (error) {
      toast.error("Müşteri verileri alınamadı");
    }
  };

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const renderModuleList = (modules, isZet) => {
    const list = Array.isArray(modules) ? modules : [];
    const filteredModules = list.filter((module) => module.IsZet === isZet);

    if (filteredModules.length === 0) {
      return (
        <Typography variant="body2" sx={{ color: modernTheme.text.secondary, fontStyle: "italic" }}>
          Bulunmamaktadır
        </Typography>
      );
    }

    return (
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
        {filteredModules.map((module) => (
          <Chip
            key={module.Id}
            label={module.ProgramAdi}
            size="small"
            sx={{
              bgcolor: modernTheme.background.main,
              color: modernTheme.text.secondary,
              border: `1px solid ${modernTheme.border}`,
              fontWeight: 500,
              fontSize: "0.8125rem",
              transition: "all 0.2s ease",
              '&:hover': {
                bgcolor: modernTheme.primaryLight,
                color: modernTheme.primary,
                borderColor: modernTheme.border,
                transform: "translateY(-1px)",
                boxShadow: `0 2px 8px rgba(0, 0, 0, 0.08)`
              },
            }}
          />
        ))}
      </Box>
    );
  };

  const hasBulutSunucu = orders.some(
    (o) => o.details?.SunucuTipi === "Bulut Sunucu" || o.details?.SunucuTipi === "Bulut"
  );

  const toDateKey = (value) => {
    if (!value) return null;
    const d = new Date(value);
    return Number.isNaN(d.getTime()) ? null : d.toISOString().slice(0, 10);
  };

  /** Satırdaki lisansın siparişinde seçilen sunucu tipi (Bulut / Yerel) */
  const resolveLicenseSunucuTipi = (lisans) => {
    if (lisans?.KurulumTipi) return lisans.KurulumTipi;
    if (lisans?.SunucuTipi) return lisans.SunucuTipi;

    const userNo = Number(lisans?.UserNo);
    if (!Number.isFinite(userNo)) return null;

    const baslangicKey = toDateKey(lisans?.BaslangicTarih);
    const orderRows = orders
      .map((o) => o.details || o)
      .filter((d) => d?.SunucuTipi && Number(d.UserNo) === userNo)
      .sort((a, b) => Number(b.Id || 0) - Number(a.Id || 0));

    if (!orderRows.length) return null;

    if (baslangicKey) {
      const byDate = orderRows.find(
        (d) => toDateKey(d.LisansBaslangicTarihi) === baslangicKey,
      );
      if (byDate?.SunucuTipi) return byDate.SunucuTipi;
    }

    return orderRows[0]?.SunucuTipi || null;
  };

  const isGastoraLicenseRow = (row) => {
    const key = String(row?.LisansKey || "");
    return (
      key.startsWith("GST") ||
      row?.UrunAilesi === "Gastora" ||
      row?.UrunAilesi === "Gastro" ||
      row?.enabledAddonsJson != null
    );
  };

  /** Her lisans satırı kendi paket / ek modül / sunucu tipi ile sertifika üretir */
  const openLicenseCertificate = (lisans) => {
    const sunucuTipi = resolveLicenseSunucuTipi(lisans);
    handleCertificateGenerate(
      {
        ...lisans,
        ...(sunucuTipi ? { SunucuTipi: sunucuTipi } : {}),
      },
      userData,
      { Adi: lisans.PaketAdi },
      customer,
      isGastoraLicenseRow(lisans) ? [] : (lisans.EkModuller?.length ? lisans.EkModuller : customerEkModule),
      navigate,
    );
  };

  const handleLicenseAdd = (id) => {
    navigate(`/lisanslar/lisans-talep/musteri/${id}`);
  };

  const handleOrderAdd = (id) => {
    navigate(`/siparis/musteri/${id}`);
  };

  const handleDownloadFile = async (fileName) => {
    setDownloadingFiles((prev) => [...prev, fileName]);
    const fileUrl = `${config.baseURL}/musteriler/musteri-dokuman/download/${fileName}`;
    try {
      const response = await fetch(fileUrl, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (!response.ok) throw new Error("Dosya indirilemedi.");
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = fileName;
      link.click();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Download error:", error);
    } finally {
      setDownloadingFiles((prev) => prev.filter((f) => f !== fileName));
    }
  };

  const handleFileUpload = async (event) => {
    const files = event.target.files;
    if (!files.length) return;

    for (const file of files) {
      if (file.size > MAX_FILE_SIZE_MB * 1024 * 1024) {
        toast.error("Maksimum dosya boyutu 10MB olmalıdır.");
        return;
      }
    }

    setUploading(true);
    const formData = new FormData();

    Array.from(files).forEach(file => {
        formData.append('customerFiles', file);
    });

    try {
        const response = await axios.post(
            `${config.baseURL}/musteriler/musteri-dokuman/upload-document/${customer.Id}`,
            formData,
            {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'multipart/form-data',
                }
            }
        );

        if (response.data.success) {
            toast.success('Dökümanlar başarıyla yüklendi');
            fetchCustomerFiles(customer.Id, token);
        }
    } catch (error) {
        toast.error('Döküman yüklenirken hata oluştu');
    } finally {
        setUploading(false);
    }
  };

  const handleFileDeleted = () => {
    fetchCustomerFiles(customer.Id, token);
  };

  // Mobile Card Components (Modern)
  const MobileOrderCard = ({ order }) => {
    const [open, setOpen] = useState(false);

    return (
      <Card
        sx={{
          mb: 2,
          borderRadius: 3,
          border: `1px solid ${modernTheme.border}`,
          boxShadow: "none",
          transition: "all 0.2s ease",
          "&:hover": {
            boxShadow: `0 4px 12px rgba(0, 0, 0, 0.08)`,
            transform: "translateY(-2px)"
          }
        }}
      >
        <CardContent sx={{ p: 2.5 }}>
          <Stack direction="row" justifyContent="space-between" alignItems="center" mb={2}>
            <Typography variant="subtitle1" fontWeight={600} sx={{ color: modernTheme.text.primary }}>
              Sipariş #{order.Id}
            </Typography>
            <Chip
              label={order.DurumAd}
              color={getStatusColor(order.DurumAd)}
              size="small"
              sx={{ fontWeight: 600 }}
            />
          </Stack>

          <Stack spacing={1.5}>
            <Stack
              direction="row"
              justifyContent="space-between"
              sx={{
                p: 1.5,
                borderRadius: 2,
                bgcolor: modernTheme.background.main
              }}
            >
              <Typography variant="body2" sx={{ color: modernTheme.text.secondary, fontWeight: 500 }}>Tarih:</Typography>
              <Typography variant="body2" sx={{ color: modernTheme.text.primary, fontWeight: 600 }}>{formatDate(order.Tarih)}</Typography>
            </Stack>

            <Stack
              direction="row"
              justifyContent="space-between"
              sx={{
                p: 1.5,
                borderRadius: 2,
                bgcolor: modernTheme.background.main
              }}
            >
              <Typography variant="body2" sx={{ color: modernTheme.text.secondary, fontWeight: 500 }}>Paket:</Typography>
              <Typography variant="body2" sx={{ color: modernTheme.text.primary, fontWeight: 600 }}>
                {order.details?.Hareketler?.find((h) => h.EkModul === false)?.PaketAdi || "N/A"}
              </Typography>
            </Stack>

            <Button
              size="small"
              onClick={() => setOpen(!open)}
              endIcon={open ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
              sx={{
                alignSelf: 'flex-start',
                mt: 1,
                textTransform: "none",
                color: modernTheme.accent,
                fontWeight: 600,
                "&:hover": {
                  bgcolor: "rgba(0, 167, 181, 0.04)"
                }
              }}
            >
              {open ? 'Daha Az' : 'Detaylar'}
            </Button>

            <Collapse in={open}>
              <Stack spacing={2} mt={1}>
                <Box
                  sx={{
                    p: 1.5,
                    borderRadius: 2,
                    bgcolor: modernTheme.background.main,
                    border: `1px solid ${modernTheme.borderLight}`
                  }}
                >
                  <Typography variant="caption" sx={{ color: modernTheme.text.secondary, display: "block", mb: 1, fontWeight: 600 }}>
                    Ek Modüller:
                  </Typography>
                  <Typography variant="body2">
                    {order.details?.Hareketler
                      ?.filter((h) => h.EkModul === true)
                      .map((h) => h.name)
                      .join(", ") || "Ek Modul Bulunmuyor"}
                  </Typography>
                </Box>

                <Button
                  fullWidth
                  variant="contained"
                  onClick={() => navigate(`/siparis/${order.Id}`)}
                  sx={{
                    bgcolor: modernTheme.accent,
                    textTransform: "none",
                    fontWeight: 600,
                    "&:hover": {
                      bgcolor: modernTheme.accentHover
                    }
                  }}
                >
                  Detayları Görüntüle
                </Button>
              </Stack>
            </Collapse>
          </Stack>
        </CardContent>
      </Card>
    );
  };

  const MobileLicenseCard = ({ lisans, isBayiFullAccess, onPasifeAl }) => {
    const [open, setOpen] = useState(false);

    return (
      <Card
        sx={{
          mb: 2,
          borderRadius: 3,
          border: `1px solid ${modernTheme.border}`,
          boxShadow: "none",
          transition: "all 0.2s ease",
          "&:hover": {
            boxShadow: `0 4px 12px rgba(0, 0, 0, 0.08)`,
            transform: "translateY(-2px)"
          }
        }}
      >
        <CardContent sx={{ p: 2.5 }}>
          <Stack direction="row" justifyContent="space-between" alignItems="center" mb={2}>
            <Typography variant="subtitle1" fontWeight={600} sx={{ color: modernTheme.text.primary }}>
              Client ID: {lisans.UserNo}
            </Typography>
            <Chip
              label={getLisansDurumLabel(lisans)}
              color={getStatusColor(getLisansDurumLabel(lisans))}
              size="small"
              sx={{ fontWeight: 600 }}
            />
          </Stack>

          <Stack spacing={1.5}>
            <Stack
              direction="row"
              justifyContent="space-between"
              sx={{
                p: 1.5,
                borderRadius: 2,
                bgcolor: modernTheme.background.main
              }}
            >
              <Typography variant="body2" sx={{ color: modernTheme.text.secondary, fontWeight: 500 }}>Kullanıcı Sayısı:</Typography>
              <Typography variant="body2" sx={{ color: modernTheme.text.primary, fontWeight: 600 }}>
                {lisans.UserCount}
              </Typography>
            </Stack>

            <Stack
              direction="row"
              justifyContent="space-between"
              sx={{
                p: 1.5,
                borderRadius: 2,
                bgcolor: modernTheme.background.main
              }}
            >
              <Typography variant="body2" sx={{ color: modernTheme.text.secondary, fontWeight: 500 }}>Başlangıç:</Typography>
              <Typography variant="body2" sx={{ color: modernTheme.text.primary, fontWeight: 600 }}>
                {new Date(lisans.BaslangicTarih).toLocaleDateString("tr-TR")}
              </Typography>
            </Stack>

            <Stack
              direction="row"
              justifyContent="space-between"
              sx={{
                p: 1.5,
                borderRadius: 2,
                bgcolor: modernTheme.background.main
              }}
            >
              <Typography variant="body2" sx={{ color: modernTheme.text.secondary, fontWeight: 500 }}>Bitiş:</Typography>
              <Typography variant="body2" sx={{ color: modernTheme.text.primary, fontWeight: 600 }}>
                {new Date(lisans.BitisTarih).toLocaleDateString("tr-TR")}
              </Typography>
            </Stack>

            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              sx={{
                p: 1.5,
                borderRadius: 2,
                bgcolor: modernTheme.background.main
              }}
            >
              <Typography variant="body2" sx={{ color: modernTheme.text.secondary, fontWeight: 500 }}>Kullanım:</Typography>
              <Chip
                label={lisans.UniqueNumber ? "Kullanımda" : "Boşta"}
                color={getStatusColor(lisans.UniqueNumber ? "Kullanımda" : "Boşta")}
                size="small"
                sx={{ fontWeight: 600 }}
              />
            </Stack>

            <Button
              size="small"
              onClick={() => setOpen(!open)}
              endIcon={open ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
              sx={{
                alignSelf: 'flex-start',
                mt: 1,
                textTransform: "none",
                color: modernTheme.accent,
                fontWeight: 600,
                "&:hover": {
                  bgcolor: "rgba(0, 167, 181, 0.04)"
                }
              }}
            >
              {open ? 'Daha Az' : 'İşlemler'}
            </Button>

            <Collapse in={open}>
              <Box mt={2} sx={{
                p: 2,
                borderRadius: 2,
                bgcolor: modernTheme.background.main,
                border: `1px solid ${modernTheme.borderLight}`
              }}>
                <LicenseActions
                  lisans={lisans}
                  onRenewLicense={handleRenewLicense}
                  onCopyLicenseInfo={() => handleCopyLicenseInfo(lisans, customer)}
                  onCertificateGenerate={() => openLicenseCertificate(lisans)}
                  onPasifeAl={onPasifeAl}
                  isBayiFullAccess={isBayiFullAccess}
                />
              </Box>
            </Collapse>
          </Stack>
        </CardContent>
      </Card>
    );
  };

  const MobileFileCard = ({ file }) => {
    return (
      <Card
        sx={{
          mb: 2,
          borderRadius: 3,
          border: `1px solid ${modernTheme.border}`,
          boxShadow: "none",
          transition: "all 0.2s ease",
          "&:hover": {
            boxShadow: `0 4px 12px rgba(0, 0, 0, 0.08)`,
            transform: "translateY(-2px)"
          }
        }}
      >
        <CardContent sx={{ p: 2.5 }}>
          <Stack direction="row" alignItems="center" spacing={2} mb={2}>
            <Box>
              {file.icon}
            </Box>
            <Typography variant="body1" fontWeight={600} sx={{
              flex: 1,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              color: modernTheme.text.primary
            }}>
              {file.name}
            </Typography>
          </Stack>

          <Stack spacing={1.5}>
            <Stack
              direction="row"
              justifyContent="space-between"
              sx={{
                p: 1.5,
                borderRadius: 2,
                bgcolor: modernTheme.background.main
              }}
            >
              <Typography variant="body2" sx={{ color: modernTheme.text.secondary, fontWeight: 500 }}>Kaynak:</Typography>
              <Typography variant="body2" sx={{ color: modernTheme.text.primary, fontWeight: 600 }}>{file.IslemTipi}</Typography>
            </Stack>

            <Stack
              direction="row"
              justifyContent="space-between"
              sx={{
                p: 1.5,
                borderRadius: 2,
                bgcolor: modernTheme.background.main
              }}
            >
              <Typography variant="body2" sx={{ color: modernTheme.text.secondary, fontWeight: 500 }}>Boyut:</Typography>
              <Typography variant="body2" sx={{ color: modernTheme.text.primary, fontWeight: 600 }}>{formatFileSize(file.size)}</Typography>
            </Stack>

            <Stack direction="row" spacing={1} mt={1}>
              <Button
                fullWidth
                variant="contained"
                startIcon={downloadingFiles.includes(file.systemName) ?
                  <CircularProgress size={16} /> : <FileDownloadIcon />}
                onClick={() => handleDownloadFile(file.systemName)}
                disabled={downloadingFiles.includes(file.systemName)}
                sx={{
                  bgcolor: modernTheme.accent,
                  textTransform: "none",
                  fontWeight: 600,
                  "&:hover": {
                    bgcolor: modernTheme.accentHover
                  }
                }}
              >
                İndir
              </Button>

              <DeleteFileDialog
                dokumanId={file.dokumanId}
                onSuccess={handleFileDeleted}
              />
            </Stack>
          </Stack>
        </CardContent>
      </Card>
    );
  };

  const MobileProgramCard = ({ program }) => {
    return (
      <Card
        sx={{
          mb: 2,
          borderRadius: 3,
          border: `1px solid ${modernTheme.border}`,
          boxShadow: "none",
          transition: "all 0.2s ease",
          "&:hover": {
            boxShadow: `0 4px 12px rgba(0, 0, 0, 0.08)`,
            transform: "translateY(-2px)"
          }
        }}
      >
        <CardContent sx={{ p: 2.5 }}>
          <Stack direction="row" justifyContent="space-between" alignItems="center" mb={1.5}>
            <Typography variant="subtitle1" fontWeight={600} sx={{ color: modernTheme.text.primary }}>
              {program.programAdi}
            </Typography>
            <Chip
              label={(program.ProgramToCustomers?.[0]?.Iptal === false || program.ProgramToCustomers?.[0]?.Iptal === 0) ? 'Aktif' : 'Pasif'}
              color={getStatusColor((program.ProgramToCustomers?.[0]?.Iptal === false || program.ProgramToCustomers?.[0]?.Iptal === 0) ? 'Aktif' : 'Pasif')}
              size="small"
              sx={{ fontWeight: 600 }}
            />
          </Stack>

          <Box
            sx={{
              p: 1.5,
              borderRadius: 2,
              bgcolor: modernTheme.background.main
            }}
          >
            <Typography variant="caption" sx={{ color: modernTheme.text.secondary, fontWeight: 500 }}>
              Program Kodu:
            </Typography>
            <Typography variant="body2" sx={{ color: modernTheme.text.primary, fontWeight: 600, mt: 0.5 }}>
              {program.ProgramKodu}
            </Typography>
          </Box>
        </CardContent>
      </Card>
    );
  };

  if (error) {
    return (
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        minHeight="100vh"
        p={2}
      >
        <Paper
          elevation={0}
          sx={{
            p: 4,
            maxWidth: 400,
            borderRadius: 3,
            border: `1px solid ${modernTheme.error}`,
            bgcolor: modernTheme.background.white
          }}
        >
          <Typography
            color="error"
            align="center"
            variant="h6"
            fontWeight={600}
            sx={{ mb: 1 }}
          >
            ⚠️ Hata Oluştu
          </Typography>
          <Typography color="text.secondary" align="center">
            {error}
          </Typography>
        </Paper>
      </Box>
    );
  }

  if (!token || !userData || !customer || loading) {
    return (
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        minHeight="100vh"
      >
        <Loading />
      </Box>
    );
  }

  // Mobile Layout (Modern)
  if (isMobile) {
    return (
      <>
        <Box sx={{ p: 2, bgcolor: modernTheme.background.main, minHeight: "100vh" }}>
          {/* Customer Info Header - Collapsible on Mobile */}
          <Paper
            elevation={0}
            sx={{
              mb: 2,
              borderRadius: 3,
              border: `1px solid ${modernTheme.border}`,
              overflow: "hidden"
            }}
          >
            <Box
              sx={{
                p: 2,
                cursor: 'pointer',
                bgcolor: modernTheme.background.white,
                transition: "all 0.2s ease",
                "&:hover": {
                  bgcolor: modernTheme.background.main
                }
              }}
              onClick={() => setShowCustomerInfo(!showCustomerInfo)}
            >
              <Stack direction="row" justifyContent="space-between" alignItems="center">
                <Stack direction="row" alignItems="center" spacing={1.5}>
                  <Box
                    sx={{
                      width: 36,
                      height: 36,
                      borderRadius: 2,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      bgcolor: modernTheme.background.main,
                      color: modernTheme.text.secondary
                    }}
                  >
                    <Business fontSize="small" />
                  </Box>
                  <Typography variant="h6" sx={{ fontWeight: 600, color: modernTheme.text.primary }}>
                    {customer.Unvan}
                  </Typography>
                </Stack>
                {showCustomerInfo ?
                  <KeyboardArrowUp sx={{ color: modernTheme.text.secondary }} /> :
                  <KeyboardArrowDown sx={{ color: modernTheme.text.secondary }} />
                }
              </Stack>
            </Box>

            <Collapse in={showCustomerInfo}>
              <Box sx={{ p: 2.5, pt: 0, bgcolor: modernTheme.background.main }}>
                <Chip
                  label={`ID: ${customer.MusteriNo}`}
                  size="small"
                  sx={{
                    mb: 2,
                    bgcolor: modernTheme.background.main,
                    color: modernTheme.text.secondary,
                    fontWeight: 600,
                    border: `1px solid ${modernTheme.border}`
                  }}
                />

                <Stack spacing={1.5}>
                  <Stack
                    direction="row"
                    alignItems="center"
                    spacing={1.5}
                    sx={{
                      p: 1.5,
                      borderRadius: 2,
                      bgcolor: modernTheme.background.white
                    }}
                  >
                    <Email fontSize="small" color="action" />
                    <Typography variant="body2" sx={{ wordBreak: "break-word", color: modernTheme.text.primary }}>
                      {customer.EPosta}
                    </Typography>
                  </Stack>

                  <Stack
                    direction="row"
                    alignItems="center"
                    spacing={1.5}
                    sx={{
                      p: 1.5,
                      borderRadius: 2,
                      bgcolor: modernTheme.background.white
                    }}
                  >
                    <Phone fontSize="small" color="action" />
                    <Typography variant="body2" sx={{ color: modernTheme.text.primary }}>
                      {customer.Tel && customer.Tel2
                        ? `${customer.Tel} / ${customer.Tel2}`
                        : customer.Tel || customer.Tel2 || "Belirtilmemiş"}
                    </Typography>
                  </Stack>

                  <Stack
                    spacing={0.5}
                    sx={{
                      p: 1.5,
                      borderRadius: 2,
                      bgcolor: modernTheme.background.white
                    }}
                  >
                    <Stack direction="row" alignItems="flex-start" spacing={1.5}>
                      <LocationOn fontSize="small" color="action" sx={{ mt: 0.3 }} />
                      <Box>
                        <Typography variant="body2" sx={{ mb: 0.5, color: modernTheme.text.primary }}>
                          {customer.Adres || "Adres belirtilmemiş"}
                        </Typography>
                        <Typography variant="caption" sx={{ color: modernTheme.text.secondary }}>
                          {customer.Ilce || "—"}, {customer.Il || "—"}
                        </Typography>
                        {customer.Aciklama ? (
                          <Typography variant="body2" sx={{ mt: 1, color: modernTheme.text.secondary, whiteSpace: "pre-wrap" }}>
                            {customer.Aciklama}
                          </Typography>
                        ) : null}
                      </Box>
                    </Stack>
                  </Stack>
                </Stack>

                <Divider sx={{ my: 2 }} />

                {/* Package Info */}
                {customerPackage.Adi && (
                  <Stack spacing={2}>
                    <Box
                      sx={{
                        p: 2,
                        borderRadius: 2,
                        bgcolor: modernTheme.background.white,
                        border: `1px solid ${modernTheme.borderLight}`
                      }}
                    >
                      <Typography variant="caption" sx={{ color: modernTheme.text.secondary, textTransform: "uppercase", fontSize: "0.7rem", display: "block", mb: 0.5 }}>
                        Paket Adı
                      </Typography>
                      <Typography variant="body2" fontWeight={600} sx={{ color: modernTheme.text.primary }}>
                        {customerPackage.Adi}
                      </Typography>
                    </Box>

                    <Box>
                      <Typography variant="caption" sx={{ color: modernTheme.text.secondary, display: "block", mb: 1, fontWeight: 600 }}>
                        Ek Modüller:
                      </Typography>
                      {renderModuleList(customerEkModule, true)}
                    </Box>

                    {hasBulutSunucu && (
                      <Box>
                        <Typography variant="caption" sx={{ color: modernTheme.text.secondary, display: "block", mb: 1, fontWeight: 600 }}>
                          Bulut Sunucusu
                        </Typography>
                        <Chip
                          label="Var"
                          size="small"
                          sx={{
                            bgcolor: modernTheme.background.main,
                            color: modernTheme.text.secondary,
                            border: `1px solid ${modernTheme.border}`,
                            fontWeight: 500,
                            fontSize: "0.8125rem",
                          }}
                        />
                      </Box>
                    )}

                    <Box>
                      <Typography variant="caption" sx={{ color: modernTheme.text.secondary, display: "block", mb: 1, fontWeight: 600 }}>
                        Ek Programlar:
                      </Typography>
                      {renderModuleList(customerEkModule, false)}
                    </Box>
                  </Stack>
                )}

                <Button
                  fullWidth
                  variant="contained"
                  startIcon={<FaPenToSquare />}
                  onClick={handleEdit}
                  sx={{
                    mt: 2.5,
                    bgcolor: modernTheme.accent,
                    textTransform: "none",
                    fontWeight: 600,
                    boxShadow: `0 4px 12px rgba(0, 167, 181, 0.3)`,
                    "&:hover": {
                      bgcolor: modernTheme.accentHover,
                      boxShadow: `0 6px 16px rgba(0, 167, 181, 0.4)`,
                    }
                  }}
                >
                  Düzenle
                </Button>
              </Box>
            </Collapse>
          </Paper>

          {/* Tabs */}
          <Paper
            elevation={0}
            sx={{
              borderRadius: 3,
              border: `1px solid ${modernTheme.border}`,
              overflow: "hidden"
            }}
          >
            <Tabs
              value={activeTab}
              onChange={handleTabChange}
              variant="scrollable"
              scrollButtons="auto"
              sx={{
                borderBottom: 1,
                borderColor: modernTheme.border,
                bgcolor: modernTheme.background.main,
                '& .MuiTab-root': {
                  textTransform: "none",
                  fontWeight: 500,
                  fontSize: "0.875rem",
                  minHeight: 52,
                  color: modernTheme.text.secondary,
                  '&:hover': {
                    color: modernTheme.accent,
                    bgcolor: "rgba(0, 167, 181, 0.04)"
                  },
                  '&.Mui-selected': {
                    color: modernTheme.accent,
                    fontWeight: 600
                  }
                },
                '& .MuiTabs-indicator': {
                  height: 3,
                  borderRadius: "3px 3px 0 0",
                  bgcolor: modernTheme.accent
                }
              }}
            >
              <Tab icon={<ShoppingCart fontSize="small" />} label="Siparişler" value="siparisler" />
              <Tab icon={<Inventory fontSize="small" />} label="Modüller" value="paketler" />
              <Tab icon={<Description fontSize="small" />} label="Dökümanlar" value="dokumanlar" />
              <Tab icon={<Key fontSize="small" />} label="Lisanslar" value="lisanslar" />
              <Tab icon={<Restaurant fontSize="small" />} label="Gastro Lisansları" value="gastora-lisanslar" />
              <Tab icon={<Headset fontSize="small" />} label="Destek" value="destek" />
            </Tabs>

            <Box sx={{
              p: 2,
              maxHeight: 'calc(100vh - 280px)',
              overflowY: 'auto',
              bgcolor: modernTheme.background.white,
              '&::-webkit-scrollbar': {
                width: '6px',
              },
              '&::-webkit-scrollbar-track': {
                background: modernTheme.borderLight,
                borderRadius: '3px',
              },
              '&::-webkit-scrollbar-thumb': {
                background: modernTheme.border,
                borderRadius: '3px',
                '&:hover': {
                  background: modernTheme.text.light,
                },
              },
            }}>
              {/* Orders Tab */}
              {activeTab === "siparisler" && (
                <Box>
                  {orders.length > 0 ? (
                    orders.map((order) => (
                      <MobileOrderCard key={order.Id} order={order} />
                    ))
                  ) : (
                    <Typography align="center" color="text.secondary">
                      Henüz sipariş verisi yok
                    </Typography>
                  )}

                  <Button
                    fullWidth
                    variant="contained"
                    startIcon={<AddCircleOutline />}
                    onClick={() => handleOrderAdd(customer.Id)}
                    sx={{
                      mt: 2,
                      mb: 2,
                      bgcolor: modernTheme.accent,
                      textTransform: "none",
                      fontWeight: 600,
                      py: 1.25,
                      boxShadow: `0 4px 12px rgba(0, 167, 181, 0.3)`,
                      "&:hover": {
                        bgcolor: modernTheme.accentHover,
                        boxShadow: `0 6px 16px rgba(0, 167, 181, 0.4)`,
                      }
                    }}
                  >
                    Sipariş Ekle
                  </Button>
                </Box>
              )}

              {/* Programs Tab */}
              {activeTab === "paketler" && (
                <Box>
                  {programs?.length > 0 ? (
                    programs.map((program) => (
                      <MobileProgramCard key={program.Id} program={program} />
                    ))
                  ) : (
                    <Typography align="center" color="text.secondary">
                      Henüz paket verisi yok
                    </Typography>
                  )}
                </Box>
              )}

              {/* Documents Tab */}
              {activeTab === "dokumanlar" && (
                <Box>
                  {customerFiles.length > 0 ? (
                    customerFiles.map((file, index) => (
                      <MobileFileCard key={index} file={file} />
                    ))
                  ) : (
                    <Typography align="center" color="text.secondary">
                      Henüz döküman verisi yok
                    </Typography>
                  )}

                  <Button
                    fullWidth
                    component="label"
                    variant="contained"
                    startIcon={<CloudUploadIcon />}
                    disabled={uploading}
                    sx={{
                      mt: 2,
                      mb: 2,
                      bgcolor: modernTheme.accent,
                      textTransform: "none",
                      fontWeight: 600,
                      py: 1.25,
                      boxShadow: `0 4px 12px rgba(0, 167, 181, 0.3)`,
                      "&:hover": {
                        bgcolor: modernTheme.accentHover,
                        boxShadow: `0 6px 16px rgba(0, 167, 181, 0.4)`,
                      }
                    }}
                  >
                    {uploading ? 'Yükleniyor...' : 'Döküman Yükle'}
                    <input
                      type="file"
                      multiple
                      hidden
                      onChange={handleFileUpload}
                      accept="application/pdf"
                    />
                  </Button>
                </Box>
              )}

              {/* Licenses Tab */}
              {activeTab === "lisanslar" && (
                <Box>
                  {customerLicenses?.length > 0 ? (
                    customerLicenses.map((lisans) => (
                      <MobileLicenseCard key={lisans.Id} lisans={lisans} isBayiFullAccess={isBayiFullAccess} onPasifeAl={handleMusteriLisansPasifeAl} />
                    ))
                  ) : (
                    <Typography align="center" color="text.secondary">
                      Henüz lisans verisi yok
                    </Typography>
                  )}

                  <Button
                    fullWidth
                    variant="contained"
                    startIcon={<AddCircleOutline />}
                    onClick={() => handleLicenseAdd(customer.Id)}
                    sx={{
                      mt: 2,
                      mb: 2,
                      bgcolor: modernTheme.accent,
                      textTransform: "none",
                      fontWeight: 600,
                      py: 1.25,
                      boxShadow: `0 4px 12px rgba(0, 167, 181, 0.3)`,
                      "&:hover": {
                        bgcolor: modernTheme.accentHover,
                        boxShadow: `0 6px 16px rgba(0, 167, 181, 0.4)`,
                      }
                    }}
                  >
                    Lisans Ekle
                  </Button>
                </Box>
              )}

              {activeTab === "gastora-lisanslar" && (
                <Box>
                  {gastoraLicenses?.length > 0 ? (
                    gastoraLicenses.map((gl) => (
                      <Card key={gl.Id} sx={{ mb: 1.5, borderRadius: 2 }}>
                        <CardContent>
                          <Stack direction="row" justifyContent="space-between" alignItems="flex-start" mb={1}>
                            <Typography variant="subtitle2"><code>{gl.LisansKey}</code></Typography>
                            {gastoraDurumChip(gl)}
                          </Stack>
                          <Typography variant="body2" color="text.secondary">
                            {gl.LisansTipi} · {gl.UrunAilesi || "Gastro"}
                          </Typography>
                          <Typography variant="caption" display="block">
                            {gl.BaslangicTarih ? new Date(gl.BaslangicTarih).toLocaleDateString("tr-TR") : "-"}
                            {" — "}
                            {gl.BitisTarih ? new Date(gl.BitisTarih).toLocaleDateString("tr-TR") : "-"}
                          </Typography>
                          <Chip size="small" sx={{ mt: 1 }} label={[gl.moduleQrMenu && "QR", gl.moduleRestoran && "Restoran", gl.modulePaketServis && "Paket", gl.moduleUretim && "Üretim"].filter(Boolean).join(", ") || "Modül yok"} />
                          <Box sx={{ mt: 1.5 }}>{gastoraLicenseActions(gl)}</Box>
                        </CardContent>
                      </Card>
                    ))
                  ) : (
                    <Typography align="center" color="text.secondary">Henüz Gastro lisansı yok</Typography>
                  )}
                  <Button fullWidth variant="contained" startIcon={<AddCircleOutline />} onClick={() => navigate(`/gastora/siparis/musteri/${customer.Id}`)} sx={{ mt: 2, bgcolor: modernTheme.accent, textTransform: "none" }}>
                    Gastro Sipariş Ekle
                  </Button>
                </Box>
              )}

              {/* Support Tab */}
              {activeTab === "destek" && (
                <Box>
                  {customerSupports?.length > 0 ? (
                    customerSupports.map((support) => (
                      <Card
                        key={support.Id}
                        sx={{
                          mb: 2,
                          border: `1px solid ${modernTheme.border}`,
                          borderRadius: 2,
                          overflow: "hidden",
                        }}
                      >
                        <CardContent>
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "flex-start",
                              mb: 1,
                            }}
                          >
                            <Typography variant="h6" fontWeight={600}>
                              {support.GorusulenKisi}
                            </Typography>
                            <Chip
                              label={support.Durum}
                              size="small"
                              sx={{
                                bgcolor:
                                  support.Durum === "Destek Verildi"
                                    ? "#10B981"
                                    : support.Durum === "Ar-Ge'ye iletildi"
                                    ? "#3B82F6"
                                    : "#EF4444",
                                color: "white",
                                fontWeight: 500,
                              }}
                            />
                          </Box>
                          {support.Telefon && (
                            <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                              Telefon: {support.Telefon}
                            </Typography>
                          )}
                          {support.DestekTuru && (
                            <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                              Tür: {support.DestekTuru}
                            </Typography>
                          )}
                          {support.Modul && (
                            <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                              Modül: {support.Modul}
                            </Typography>
                          )}
                          {(support.BaslangicSaati || support.BitisSaati) && (
                            <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                              Saatler: {formatTimeOnly(support.BaslangicSaati)} - {formatTimeOnly(support.BitisSaati)}
                            </Typography>
                          )}
                          {support.DestekAciklamasi && (
                            <Typography variant="body2" sx={{ mt: 1 }}>
                              {support.DestekAciklamasi}
                            </Typography>
                          )}
                          <Typography
                            variant="caption"
                            color="text.secondary"
                            sx={{ display: "block", mt: 1 }}
                          >
                            {new Date(support.OlusturmaTarihi).toLocaleDateString("tr-TR")}
                          </Typography>
                        </CardContent>
                      </Card>
                    ))
                  ) : (
                    <Typography align="center" color="text.secondary">
                      Henüz destek kaydı yok
                    </Typography>
                  )}

                  <Button
                    fullWidth
                    variant="contained"
                    startIcon={<AddCircleOutline />}
                    onClick={() => {
                      navigate(`/destek?musteriId=${customer.Id}`);
                    }}
                    sx={{
                      mt: 2,
                      mb: 2,
                      bgcolor: modernTheme.accent,
                      textTransform: "none",
                      fontWeight: 600,
                      py: 1.25,
                      boxShadow: `0 4px 12px rgba(0, 167, 181, 0.3)`,
                      "&:hover": {
                        bgcolor: modernTheme.accentHover,
                        boxShadow: `0 6px 16px rgba(0, 167, 181, 0.4)`,
                      },
                    }}
                  >
                    Destek Ekle
                  </Button>
                </Box>
              )}
            </Box>
          </Paper>
        </Box>

        <Drawer
          open={isDrawerOpen}
          onClose={toggleDrawer}
          direction="right"
          className="custom-drawer"
          duration={120}
          zIndex={600}
        >
          <Box
            sx={{
              height: '100%',
              overflowY: 'auto',
              bgcolor: 'background.default',
              display: 'flex',
              flexDirection: 'column'
            }}
          >
            <Box
              sx={{
                p: 2.5,
                borderBottom: 1,
                borderColor: 'divider',
                bgcolor: 'background.paper',
                position: 'sticky',
                top: 0,
                zIndex: 1,
                boxShadow: '0 1px 3px rgba(0,0,0,0.05)'
              }}
            >
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <Typography
                  variant="h6"
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1.5,
                    fontWeight: 600,
                    color: 'text.secondary',
                    fontSize: '1rem'
                  }}
                >
                  {editingCustomer ? (
                    <FaUserPen style={{ fontSize: "20px", color: "rgba(0,0,0,0.54)" }} />
                  ) : (
                    <FaUserPlus style={{ fontSize: "20px", color: "rgba(0,0,0,0.54)" }} />
                  )}
                  {editingCustomer ? "Müşteri Düzenle" : "Yeni Müşteri Ekle"}
                </Typography>
                <Box display="flex" gap={0.5}>
                  <Button
                    type="submit"
                    form="musterikaydetform"
                    variant="text"
                    size="medium"
                    sx={{
                      minWidth: 'auto',
                      p: 1,
                      color: 'text.secondary',
                      '&:hover': {
                        bgcolor: 'action.hover',
                        color: 'text.primary'
                      }
                    }}
                  >
                    <FaCheck style={{ fontSize: "18px" }} />
                  </Button>
                  <Button
                    variant="text"
                    size="medium"
                    onClick={toggleDrawer}
                    sx={{
                      minWidth: 'auto',
                      p: 1,
                      color: 'text.secondary',
                      '&:hover': {
                        bgcolor: 'action.hover',
                        color: 'text.primary'
                      }
                    }}
                  >
                    <FaX style={{ fontSize: "18px" }} />
                  </Button>
                </Box>
              </Box>
            </Box>
            <Box sx={{ flex: 1, p: 2.5, pt: 2 }}>
              <CustomerForm editingCustomer={editingCustomer} onCustomerCreated={handleCustomerCreated}/>
            </Box>
          </Box>
        </Drawer>
      </>
    );
  }

  // Desktop Layout (Modern)
  return (
    <>
    <Box sx={{ p: { xs: 2, md: 3 }, minHeight: "100vh" }}>
      <Grid container spacing={3}>
        {/* Sol Panel - Müşteri Bilgileri */}
        <Grid item xs={12} sm={12} md={4} lg={4}>
        <Paper
          elevation={0}
          sx={{
            p: 3,
            height: "calc(100vh - 48px)",
            display: 'flex',
            flexDirection: 'column',
            borderRadius: 3,
            border: `1px solid ${modernTheme.border}`,
            bgcolor: modernTheme.background.white,
          }}
        >
      {/* Müşteri Başlık Bölümü */}
      <Box sx={{ mb: 3 }}>
        <Stack direction="row" alignItems="center" spacing={1.5} mb={2}>
          <Box
            sx={{
              width: 40,
              height: 40,
              borderRadius: 2,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              bgcolor: modernTheme.background.main,
              color: modernTheme.text.secondary
            }}
          >
            <Business />
          </Box>
          <Typography variant="h6" sx={{ fontWeight: 600, color: "text.secondary", flex: 1 }}>
            Müşteri Bilgileri
          </Typography>
          <Button
            startIcon={<FaPenToSquare />}
            variant="outlined"
            size="small"
            onClick={handleEdit}
            sx={{
              borderColor: modernTheme.border,
              color: modernTheme.text.secondary,
              textTransform: "none",
              "&:hover": {
                borderColor: modernTheme.accent,
                bgcolor: "rgba(0, 167, 181, 0.04)",
                color: modernTheme.accent
              }
            }}
          >
            Düzenle
          </Button>
        </Stack>

        <Typography variant="h6" sx={{ mb: 1.5, fontWeight: 600, color: modernTheme.text.primary }}>
          {customer.Unvan}
        </Typography>
        <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
          <Chip
            label={`ID: ${customer.MusteriNo}`}
            size="small"
            sx={{
              bgcolor: modernTheme.background.main,
              color: modernTheme.text.secondary,
              fontWeight: 600,
              border: `1px solid ${modernTheme.border}`
            }}
          />
          {(programs?.length > 0) && (
            <Chip label="Pozitif Ofis" size="small" color="primary" variant="outlined" />
          )}
          {(gastoraLicenses?.length > 0) && (
            <Chip label="Gastro" size="small" sx={{ bgcolor: "#FEF3C7", color: "#92400E", fontWeight: 600 }} />
          )}
        </Stack>
      </Box>

      <Divider sx={{ my: 3 }} />

      {/* İletişim Bilgileri */}
      <Stack spacing={2.5}>
        <Typography variant="subtitle2" sx={{ fontWeight: 600, color: modernTheme.text.secondary, textTransform: "uppercase", fontSize: "0.75rem", letterSpacing: "0.5px" }}>
          İletişim Bilgileri
        </Typography>

        <Stack
          direction="row"
          alignItems="center"
          spacing={1.5}
          sx={{
            p: 1.5,
            borderRadius: 2,
            bgcolor: modernTheme.background.main,
            transition: "all 0.2s ease",
            "&:hover": {
              bgcolor: modernTheme.primaryLight
            }
          }}
        >
          <Email fontSize="small" color="action" />
          <Typography variant="body2" sx={{ wordBreak: "break-word", color: modernTheme.text.primary }}>{customer.EPosta}</Typography>
        </Stack>

        <Stack
          direction="row"
          alignItems="center"
          spacing={1.5}
          sx={{
            p: 1.5,
            borderRadius: 2,
            bgcolor: modernTheme.background.main,
            transition: "all 0.2s ease",
            "&:hover": {
              bgcolor: modernTheme.primaryLight
            }
          }}
        >
          <Phone fontSize="small" color="action" />
          <Typography variant="body2" sx={{ color: modernTheme.text.primary }}>
            {customer.Tel && customer.Tel2
              ? `${customer.Tel} / ${customer.Tel2}`
              : customer.Tel || customer.Tel2 || "Belirtilmemiş"}
          </Typography>
        </Stack>

        <Stack
          spacing={1}
          sx={{
            p: 1.5,
            borderRadius: 2,
            bgcolor: modernTheme.background.main,
            transition: "all 0.2s ease",
            "&:hover": {
              bgcolor: modernTheme.primaryLight
            }
          }}
        >
          <Stack direction="row" alignItems="flex-start" spacing={1.5}>
            <LocationOn fontSize="small" color="action" sx={{ mt: 0.3 }} />
            <Box>
              <Typography variant="body2" sx={{ mb: 0.5, color: modernTheme.text.primary }}>
                {customer.Adres || "Adres belirtilmemiş"}
              </Typography>
              <Typography variant="caption" sx={{ color: modernTheme.text.secondary }}>
                {customer.Ilce || "—"}, {customer.Il || "—"}
              </Typography>
            </Box>
          </Stack>
        </Stack>
      </Stack>

      <Divider sx={{ my: 3 }} />

      {/* Paket Bilgileri - Accordion */}
      <Box sx={{ flex: 1, minHeight: 0, overflowY:'auto' }}>
        {customerPackage.Adi ? (
          <Accordion
            expanded={expanded}
            onChange={() => setExpanded(!expanded)}
            sx={{
              '&.MuiAccordion-root': {
                boxShadow: 'none',
                bgcolor: 'transparent',
                '&:before': {
                  display: 'none',
                },
              }
            }}
          >
            <AccordionSummary
              expandIcon={<ExpandMore sx={{ color: modernTheme.text.secondary }} />}
              sx={{
                px: 0,
                minHeight: 48,
                '& .MuiAccordionSummary-content': {
                  margin: '12px 0',
                },
                '&:hover': {
                  bgcolor: 'transparent'
                }
              }}
            >
              <Typography variant="subtitle2" sx={{ fontWeight: 600, color: modernTheme.text.secondary, textTransform: "uppercase", fontSize: "0.75rem", letterSpacing: "0.5px" }}>
                Paket Bilgileri
              </Typography>
            </AccordionSummary>
            <AccordionDetails sx={{ p: 0, pt: 1.5 }}>
              <Stack
                spacing={2.5}
                sx={{
                  maxHeight: '350px',
                  overflowY: 'auto',
                  pr: 1,
                  '&::-webkit-scrollbar': {
                    width: '6px',
                  },
                  '&::-webkit-scrollbar-track': {
                    background: modernTheme.borderLight,
                    borderRadius: '3px',
                  },
                  '&::-webkit-scrollbar-thumb': {
                    background: modernTheme.border,
                    borderRadius: '3px',
                    '&:hover': {
                      background: modernTheme.text.light,
                    },
                  },
                }}
              >
                <Box
                  sx={{
                    p: 2,
                    borderRadius: 2,
                    bgcolor: modernTheme.background.main,
                    border: `1px solid ${modernTheme.borderLight}`
                  }}
                >
                  <Typography variant="caption" sx={{ color: modernTheme.text.secondary, textTransform: "uppercase", fontSize: "0.7rem", display: "block", mb: 1 }}>
                    Paket Adı
                  </Typography>
                  <Typography variant="body2" sx={{ fontWeight: 600, color: modernTheme.text.primary }}>
                    {customerPackage.Adi}
                  </Typography>
                </Box>

                {/* Ek Modüller */}
                <Box>
                  <Typography variant="caption" sx={{ color: modernTheme.text.secondary, textTransform: "uppercase", fontSize: "0.7rem", display: "block", mb: 1, fontWeight: 600 }}>
                    Ek Modüller
                  </Typography>
                  {renderModuleList(customerEkModule, true)}
                </Box>

                {hasBulutSunucu && (
                  <Box>
                    <Typography variant="caption" sx={{ color: modernTheme.text.secondary, textTransform: "uppercase", fontSize: "0.7rem", display: "block", mb: 1, fontWeight: 600 }}>
                      Bulut Sunucusu
                    </Typography>
                    <Chip
                      label="Var"
                      size="small"
                      sx={{
                        bgcolor: modernTheme.background.main,
                        color: modernTheme.text.secondary,
                        border: `1px solid ${modernTheme.border}`,
                        fontWeight: 500,
                        fontSize: "0.8125rem",
                      }}
                    />
                  </Box>
                )}

                {/* Ek Programlar */}
                <Box>
                  <Typography variant="caption" sx={{ color: modernTheme.text.secondary, textTransform: "uppercase", fontSize: "0.7rem", display: "block", mb: 1, fontWeight: 600 }}>
                    Ek Programlar
                  </Typography>
                  {renderModuleList(customerEkModule, false)}
                </Box>
              </Stack>
            </AccordionDetails>
          </Accordion>
        ) : (
          <Typography variant="body2" sx={{ color: modernTheme.text.secondary }}>
            Paket bilgisi bulunamadı.
          </Typography>
        )}
      </Box>
    </Paper>
        </Grid>

        {/* Sağ Panel - Sekmeli İçerik */}
        <Grid item xs={12} sm={12} md={8} lg={8}>
          <Paper
            elevation={0}
            sx={{
              height: "calc(100vh - 48px)",
              borderRadius: 3,
              border: `1px solid ${modernTheme.border}`,
              bgcolor: modernTheme.background.white,
              overflow: "hidden",
              display: "flex",
              flexDirection: "column"
            }}
          >
            <Box sx={{
              borderBottom: 1,
              borderColor: modernTheme.border,
              bgcolor: modernTheme.background.main,
              boxShadow: `0 1px 3px rgba(0, 0, 0, 0.05)`
            }}>
              <Tabs
                value={activeTab}
                onChange={handleTabChange}
                variant="fullWidth"
                sx={{
                  px: 2,
                  '& .MuiTab-root': {
                    textTransform: "none",
                    fontWeight: 500,
                    fontSize: "0.9rem",
                    minHeight: 56,
                    color: modernTheme.text.secondary,
                    transition: "all 0.2s ease",
                    '&:hover': {
                      color: modernTheme.accent,
                      bgcolor: "rgba(0, 167, 181, 0.04)"
                    },
                    '&.Mui-selected': {
                      color: modernTheme.accent,
                      fontWeight: 600
                    }
                  },
                  '& .MuiTabs-indicator': {
                    height: 3,
                    borderRadius: "3px 3px 0 0",
                    bgcolor: modernTheme.accent
                  }
                }}
              >
                <Tab
                  icon={<ShoppingCart />}
                  iconPosition="start"
                  label="Siparişler"
                  value="siparisler"
                />
                <Tab
                  icon={<Inventory />}
                  iconPosition="start"
                  label="Modüller"
                  value="paketler"
                />
                <Tab
                  icon={<Description />}
                  iconPosition="start"
                  label="Dökümanlar"
                  value="dokumanlar"
                />
                <Tab
                  icon={<Key />}
                  iconPosition="start"
                  label="Lisanslar"
                  value="lisanslar"
                />
                <Tab
                  icon={<Restaurant />}
                  iconPosition="start"
                  label="Gastro Lisansları"
                  value="gastora-lisanslar"
                />
                <Tab
                  icon={<Headset />}
                  iconPosition="start"
                  label="Destek"
                  value="destek"
                />
              </Tabs>
            </Box>

            <Box sx={{
              p: 3,
              flex: 1,
              overflowY: "auto",
              '&::-webkit-scrollbar': {
                width: '8px',
              },
              '&::-webkit-scrollbar-track': {
                background: modernTheme.borderLight,
                borderRadius: '4px',
              },
              '&::-webkit-scrollbar-thumb': {
                background: modernTheme.border,
                borderRadius: '4px',
                '&:hover': {
                  background: modernTheme.text.light,
                },
              },
            }}>
              {activeTab === "siparisler" && (
                <TableContainer>
                  <Table stickyHeader>
                    <TableHead>
                      <TableRow>
                        <TableCell sx={{
                          bgcolor: modernTheme.background.main,
                          fontWeight: 700,
                          color: modernTheme.text.primary,
                          borderBottom: `2px solid ${modernTheme.border}`
                        }}>
                          Sipariş No
                        </TableCell>
                        <TableCell sx={{
                          bgcolor: modernTheme.background.main,
                          fontWeight: 700,
                          color: modernTheme.text.primary,
                          borderBottom: `2px solid ${modernTheme.border}`
                        }}>
                          Tarih
                        </TableCell>
                        <TableCell sx={{
                          bgcolor: modernTheme.background.main,
                          fontWeight: 700,
                          color: modernTheme.text.primary,
                          borderBottom: `2px solid ${modernTheme.border}`
                        }}>
                          Paket
                        </TableCell>
                        <TableCell sx={{
                          bgcolor: modernTheme.background.main,
                          fontWeight: 700,
                          color: modernTheme.text.primary,
                          borderBottom: `2px solid ${modernTheme.border}`
                        }}>
                          Ek Modüller
                        </TableCell>
                        <TableCell sx={{
                          bgcolor: modernTheme.background.main,
                          fontWeight: 700,
                          color: modernTheme.text.primary,
                          borderBottom: `2px solid ${modernTheme.border}`
                        }}>
                          Durum
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {orders.length > 0 ? (
                        orders.map((order) => (

                          <TableRow
                            key={order.Id}
                            onClick={() => navigate(`/siparis/${order.Id}`)}
                            sx={{ cursor: 'pointer', '&:hover': { bgcolor: 'rgba(0, 0, 0, 0.04)' } }}
                          >
                            <TableCell>{order.Id}</TableCell>
                            <TableCell>{formatDate(order.Tarih)}</TableCell>
                            {/* EkModul === false olanlar */}
                            <TableCell>
                              {order.details?.Hareketler?.find((hareket) => hareket.EkModul === false || hareket.EkModul === 0)?.PaketAdi || "Paket adı bulunamadı"}
                            </TableCell>

                            {/* EkModul === true olanlar */}
                            <TableCell>
                              <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.75 }}>
                                {(order.details?.Hareketler || [])
                                  .filter((hareket) => hareket.EkModul === true || hareket.EkModul === 1)
                                  .map((hareket, index) => (
                                    <Chip
                                      key={index}
                                      label={hareket.name}
                                      size="small"
                                      sx={{
                                        bgcolor: modernTheme.background.main,
                                        color: modernTheme.text.secondary,
                                        fontWeight: 500,
                                        fontSize: "0.8125rem",
                                        height: "26px",
                                        border: `1px solid ${modernTheme.border}`
                                      }}
                                    />
                                  ))}
                                {(order.details?.Hareketler || []).filter((h) => h.EkModul === true || h.EkModul === 1).length === 0 && (
                                  <Typography variant="body2" color="text.secondary" sx={{ fontStyle: "italic" }}>
                                    Ek Modül Bulunmuyor
                                  </Typography>
                                )}
                              </Box>
                            </TableCell>
                            <TableCell>
                              <Chip
                                label={order.DurumAd}
                                color={getStatusColor(order.DurumAd)}
                                size="small"
                              />
                            </TableCell>
                          </TableRow>
                        ))
                      ) : (
                        <TableRow>
                          <TableCell colSpan={5} align="center">
                            Henüz sipariş verisi yok
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              )}

              {activeTab === "paketler" && (
                <TableContainer>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell sx={{
                          bgcolor: modernTheme.background.main,
                          fontWeight: 700,
                          color: modernTheme.text.primary,
                          borderBottom: `2px solid ${modernTheme.border}`
                        }}>
                          Modül Kodu
                        </TableCell>
                        <TableCell sx={{
                          bgcolor: modernTheme.background.main,
                          fontWeight: 700,
                          color: modernTheme.text.primary,
                          borderBottom: `2px solid ${modernTheme.border}`
                        }}>
                          Modül Adı
                        </TableCell>
                        <TableCell sx={{
                          bgcolor: modernTheme.background.main,
                          fontWeight: 700,
                          color: modernTheme.text.primary,
                          borderBottom: `2px solid ${modernTheme.border}`
                        }}>
                          Durum
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {programs?.length > 0 ? (
                        programs.map((program) => (
                          <TableRow key={program.Id}>
                            <TableCell>{program.ProgramKodu}</TableCell>
                            <TableCell>{program.programAdi}</TableCell>
                            <TableCell>
                              <Chip
                                label={(program.ProgramToCustomers?.[0]?.Iptal === false || program.ProgramToCustomers?.[0]?.Iptal === 0) ? 'Aktif' : 'Pasif'}
                                color={getStatusColor((program.ProgramToCustomers?.[0]?.Iptal === false || program.ProgramToCustomers?.[0]?.Iptal === 0) ? 'Aktif' : 'Pasif')}
                                size="small"
                              />
                            </TableCell>
                          </TableRow>
                        ))
                      ) : (
                        <TableRow>
                          <TableCell colSpan={4} align="center">
                            Henüz paket verisi yok
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              )}

{activeTab === "dokumanlar" && (
  <>

  <TableContainer>
    <Table>
      <TableHead>
        <TableRow>
          <TableCell width="40%" sx={{
            bgcolor: modernTheme.background.main,
            fontWeight: 700,
            color: modernTheme.text.primary,
            borderBottom: `2px solid ${modernTheme.border}`
          }}>
            Dosya Adı
          </TableCell>
          <TableCell sx={{
            bgcolor: modernTheme.background.main,
            fontWeight: 700,
            color: modernTheme.text.primary,
            borderBottom: `2px solid ${modernTheme.border}`
          }}>
            Döküman Kaynağı
          </TableCell>
          <TableCell sx={{
            bgcolor: modernTheme.background.main,
            fontWeight: 700,
            color: modernTheme.text.primary,
            borderBottom: `2px solid ${modernTheme.border}`
          }}>
            Boyut
          </TableCell>
          <TableCell sx={{
            bgcolor: modernTheme.background.main,
            fontWeight: 700,
            color: modernTheme.text.primary,
            borderBottom: `2px solid ${modernTheme.border}`
          }}>
            İşlemler
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {customerFiles.length > 0 ? (
          customerFiles.map((file, index) => (
            <TableRow key={index}>
              <TableCell sx={{
                              maxWidth: 200,
                              whiteSpace: 'nowrap',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis'
                            }}>
                {/* Dosya türüne göre ikon */}
                <Box display="flex" alignItems="center">
                  {file.icon}
                  <Typography
                      variant="body1"
                      sx={{
                        ml: 2,
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis", // İkon için yer bırakıyoruz
                      }}>
                    {file.name}
                  </Typography>
                </Box>
              </TableCell>
              <TableCell>{file.IslemTipi}</TableCell>
              <TableCell>{formatFileSize(file.size)}</TableCell>
              <TableCell>
                {/* İndirme Butonu */}
                <IconButton
                  color="primary"
                  onClick={() => handleDownloadFile(file.systemName)}
                  disabled={downloadingFiles.includes(file.systemName)}
                >
                  {downloadingFiles.includes(file.systemName) ? (
                    <CircularProgress size={20} />
                  ) : (
                    <FileDownloadIcon />
                  )}
                </IconButton>

                {/* Silme Butonu */}
                {/* {file.Silinebilir && ( */}
                  <DeleteFileDialog
                    dokumanId={file.dokumanId}
                    onSuccess={handleFileDeleted}
                  />
                {/* )} */}


              </TableCell>
            </TableRow>
          ))
        ) : (
          <TableRow>
            <TableCell colSpan={4} align="center">
              Henüz döküman verisi yok
            </TableCell>
          </TableRow>
        )}
      </TableBody>
    </Table>
  </TableContainer>
  </>
)}



{activeTab === "lisanslar" && (
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell sx={{
                    bgcolor: modernTheme.background.main,
                    fontWeight: 700,
                    color: modernTheme.text.primary,
                    borderBottom: `2px solid ${modernTheme.border}`
                  }}>
                    İşlemler
                  </TableCell>
                  <TableCell sx={{
                    bgcolor: modernTheme.background.main,
                    fontWeight: 700,
                    color: modernTheme.text.primary,
                    borderBottom: `2px solid ${modernTheme.border}`
                  }}>
                    Client Id
                  </TableCell>
                  <TableCell sx={{
                    bgcolor: modernTheme.background.main,
                    fontWeight: 700,
                    color: modernTheme.text.primary,
                    borderBottom: `2px solid ${modernTheme.border}`
                  }}>
                    Başlangıç Tarihi
                  </TableCell>
                  <TableCell sx={{
                    bgcolor: modernTheme.background.main,
                    fontWeight: 700,
                    color: modernTheme.text.primary,
                    borderBottom: `2px solid ${modernTheme.border}`
                  }}>
                    Bitiş Tarihi
                  </TableCell>
                  <TableCell sx={{
                    bgcolor: modernTheme.background.main,
                    fontWeight: 700,
                    color: modernTheme.text.primary,
                    borderBottom: `2px solid ${modernTheme.border}`
                  }}>
                    Kullanıcı Sayısı
                  </TableCell>
                  <TableCell sx={{
                    bgcolor: modernTheme.background.main,
                    fontWeight: 700,
                    color: modernTheme.text.primary,
                    borderBottom: `2px solid ${modernTheme.border}`
                  }}>
                    Lisans Tipi
                  </TableCell>
                  <TableCell sx={{
                    bgcolor: modernTheme.background.main,
                    fontWeight: 700,
                    color: modernTheme.text.primary,
                    borderBottom: `2px solid ${modernTheme.border}`
                  }}>
                    Lisans Durum
                  </TableCell>
                  <TableCell sx={{
                    bgcolor: modernTheme.background.main,
                    fontWeight: 700,
                    color: modernTheme.text.primary,
                    borderBottom: `2px solid ${modernTheme.border}`
                  }}>
                    Kullanım Durumu
                  </TableCell>
                  <TableCell sx={{
                    bgcolor: modernTheme.background.main,
                    fontWeight: 700,
                    color: modernTheme.text.primary,
                    borderBottom: `2px solid ${modernTheme.border}`
                  }}>
                    Ek Modüller
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {customerLicenses?.length > 0 ? (
                  customerLicenses.map((lisans) => (
                    <TableRow key={lisans.Id}>
                      <TableCell>
                        <LicenseActions
                          lisans={lisans}
                          onRenewLicense={handleRenewLicense}
                          onCopyLicenseInfo={() => handleCopyLicenseInfo(lisans, customer)}
                          onCertificateGenerate={() => openLicenseCertificate(lisans)}
                          onPasifeAl={handleMusteriLisansPasifeAl}
                          isBayiFullAccess={isBayiFullAccess}
                        />
                      </TableCell>
                      <TableCell>{lisans.UserNo}</TableCell>
                      <TableCell>
                        {new Date(lisans.BaslangicTarih).toLocaleDateString("tr-TR")}
                      </TableCell>
                      <TableCell>
                        {new Date(lisans.BitisTarih).toLocaleDateString("tr-TR")}
                      </TableCell>
                      <TableCell>{lisans.UserCount || "Belirtilmemiş"}</TableCell>
                      <TableCell>{lisans.LisansTipi || "Belirtilmemiş"}</TableCell>
                      <TableCell>
                        <Chip
                          label={getLisansDurumLabel(lisans)}
                          color={getStatusColor(getLisansDurumLabel(lisans))}
                          size="small"
                        />
                      </TableCell>
                      <TableCell>
                        <Chip
                          label={lisans.UniqueNumber ? "Kullanımda" : "Boşta"}
                          color={getStatusColor(lisans.UniqueNumber ? "Kullanımda" : "Boşta")}
                          size="small"
                        />
                      </TableCell>
                      <TableCell>
                        {erpEkModulesDisplay(lisans, customerEkModule)}
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={8} align="center">
                      Henüz lisans verisi yok
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        )}

        {activeTab === "gastora-lisanslar" && (
          <TableContainer>
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell sx={{ bgcolor: modernTheme.background.main, fontWeight: 700 }}>İşlem</TableCell>
                  <TableCell sx={{ bgcolor: modernTheme.background.main, fontWeight: 700 }}>Lisans Key (GST)</TableCell>
                  <TableCell sx={{ bgcolor: modernTheme.background.main, fontWeight: 700 }}>Başlangıç</TableCell>
                  <TableCell sx={{ bgcolor: modernTheme.background.main, fontWeight: 700 }}>Bitiş</TableCell>
                  <TableCell sx={{ bgcolor: modernTheme.background.main, fontWeight: 700 }}>Tip</TableCell>
                  <TableCell sx={{ bgcolor: modernTheme.background.main, fontWeight: 700 }}>Durum</TableCell>
                  <TableCell sx={{ bgcolor: modernTheme.background.main, fontWeight: 700 }}>Modüller</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {gastoraLicenses?.length > 0 ? (
                  gastoraLicenses.map((gl) => (
                    <TableRow key={gl.Id}>
                      <TableCell>
                        {gastoraLicenseActions(gl)}
                      </TableCell>
                      <TableCell><code>{gl.LisansKey}</code></TableCell>
                      <TableCell>{gl.BaslangicTarih ? new Date(gl.BaslangicTarih).toLocaleDateString("tr-TR") : "-"}</TableCell>
                      <TableCell>{gl.BitisTarih ? new Date(gl.BitisTarih).toLocaleDateString("tr-TR") : "-"}</TableCell>
                      <TableCell>{gl.LisansTipi}</TableCell>
                      <TableCell>{gastoraDurumChip(gl)}</TableCell>
                      <TableCell>{gastoraModulesDisplay(gl)}</TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow><TableCell colSpan={7} align="center">Henüz Gastro lisansı yok</TableCell></TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        )}

        {activeTab === "destek" && (
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell sx={{
                    bgcolor: modernTheme.background.main,
                    fontWeight: 700,
                    color: modernTheme.text.primary,
                    borderBottom: `2px solid ${modernTheme.border}`
                  }}>
                    Oluşturma Tarihi
                  </TableCell>
                  <TableCell sx={{
                    bgcolor: modernTheme.background.main,
                    fontWeight: 700,
                    color: modernTheme.text.primary,
                    borderBottom: `2px solid ${modernTheme.border}`
                  }}>
                    Görüşülen Kişi
                  </TableCell>
                  <TableCell sx={{
                    bgcolor: modernTheme.background.main,
                    fontWeight: 700,
                    color: modernTheme.text.primary,
                    borderBottom: `2px solid ${modernTheme.border}`
                  }}>
                    Telefon
                  </TableCell>
                  <TableCell sx={{
                    bgcolor: modernTheme.background.main,
                    fontWeight: 700,
                    color: modernTheme.text.primary,
                    borderBottom: `2px solid ${modernTheme.border}`
                  }}>
                    Destek Türü
                  </TableCell>
                  <TableCell sx={{
                    bgcolor: modernTheme.background.main,
                    fontWeight: 700,
                    color: modernTheme.text.primary,
                    borderBottom: `2px solid ${modernTheme.border}`
                  }}>
                    Modül
                  </TableCell>
                  <TableCell sx={{
                    bgcolor: modernTheme.background.main,
                    fontWeight: 700,
                    color: modernTheme.text.primary,
                    borderBottom: `2px solid ${modernTheme.border}`
                  }}>
                    Saatler
                  </TableCell>
                  <TableCell sx={{
                    bgcolor: modernTheme.background.main,
                    fontWeight: 700,
                    color: modernTheme.text.primary,
                    borderBottom: `2px solid ${modernTheme.border}`
                  }}>
                    Durum
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {customerSupports?.length > 0 ? (
                  customerSupports.map((support) => (
                    <TableRow key={support.Id} hover>
                      <TableCell>
                        {new Date(support.OlusturmaTarihi).toLocaleDateString("tr-TR")}
                      </TableCell>
                      <TableCell>{support.GorusulenKisi}</TableCell>
                      <TableCell>{support.Telefon || "-"}</TableCell>
                      <TableCell>{support.DestekTuru || "-"}</TableCell>
                      <TableCell>{support.Modul || "-"}</TableCell>
                      <TableCell>
                        {formatTimeOnly(support.BaslangicSaati)} - {formatTimeOnly(support.BitisSaati)}
                      </TableCell>
                      <TableCell>
                        <Chip
                          label={support.Durum}
                          size="small"
                          sx={{
                            bgcolor:
                              support.Durum === "Destek Verildi"
                                ? "#10B981"
                                : support.Durum === "Ar-Ge'ye iletildi"
                                ? "#3B82F6"
                                : "#EF4444",
                            color: "white",
                            fontWeight: 500,
                          }}
                        />
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={7} align="center">
                      <Typography color="text.secondary">
                        Henüz destek kaydı yok
                      </Typography>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        )}
            </Box>

            {/* Action Buttons */}
            {activeTab === "dokumanlar" && (
              <Box sx={{
                p: 2.5,
                borderTop: 1,
                borderColor: modernTheme.border,
                bgcolor: modernTheme.background.main,
                display: 'flex',
                justifyContent: 'flex-end'
              }}>
                <Button
                  component="label"
                  variant="contained"
                  startIcon={<CloudUploadIcon />}
                  disabled={uploading}
                  sx={{
                    bgcolor: modernTheme.accent,
                    textTransform: "none",
                    fontWeight: 600,
                    boxShadow: `0 4px 12px rgba(0, 167, 181, 0.3)`,
                    "&:hover": {
                      bgcolor: modernTheme.accentHover,
                      boxShadow: `0 6px 16px rgba(0, 167, 181, 0.4)`,
                      transform: "translateY(-1px)"
                    },
                    transition: "all 0.2s ease"
                  }}
                >
                  {uploading ? 'Yükleniyor...' : 'Döküman Yükle'}
                  <input
                    type="file"
                    multiple
                    hidden
                    onChange={handleFileUpload}
                    accept="application/pdf"
                  />
                </Button>
              </Box>
            )}

            {activeTab === "lisanslar" && (
              <Box sx={{
                p: 2.5,
                borderTop: 1,
                borderColor: modernTheme.border,
                bgcolor: modernTheme.background.main,
                display: 'flex',
                justifyContent: 'flex-end'
              }}>
                <Button
                  variant="contained"
                  startIcon={<AddCircleOutline />}
                  onClick={() => handleLicenseAdd(customer.Id)}
                  disabled={loading}
                  sx={{
                    bgcolor: modernTheme.accent,
                    textTransform: "none",
                    fontWeight: 600,
                    boxShadow: `0 4px 12px rgba(0, 167, 181, 0.3)`,
                    "&:hover": {
                      bgcolor: modernTheme.accentHover,
                      boxShadow: `0 6px 16px rgba(0, 167, 181, 0.4)`,
                      transform: "translateY(-1px)"
                    },
                    transition: "all 0.2s ease"
                  }}
                >
                  Lisans Ekle
                </Button>
              </Box>
            )}

            {activeTab === "destek" && (
              <Box sx={{
                p: 2.5,
                borderTop: 1,
                borderColor: modernTheme.border,
                bgcolor: modernTheme.background.main,
                display: 'flex',
                justifyContent: 'flex-end'
              }}>
                <Button
                  variant="contained"
                  startIcon={<AddCircleOutline />}
                  onClick={() => navigate(`/destek?musteriId=${customer.Id}`)}
                  disabled={loading}
                  sx={{
                    bgcolor: modernTheme.accent,
                    textTransform: "none",
                    fontWeight: 600,
                    boxShadow: `0 4px 12px rgba(0, 167, 181, 0.3)`,
                    "&:hover": {
                      bgcolor: modernTheme.accentHover,
                      boxShadow: `0 6px 16px rgba(0, 167, 181, 0.4)`,
                      transform: "translateY(-1px)"
                    },
                    transition: "all 0.2s ease"
                  }}
                >
                  Destek Ekle
                </Button>
              </Box>
            )}

            {activeTab === "siparisler" && (
              <Box sx={{
                p: 2.5,
                borderTop: 1,
                borderColor: modernTheme.border,
                bgcolor: modernTheme.background.main,
                display: 'flex',
                justifyContent: 'flex-end'
              }}>
                <Button
                  variant="contained"
                  startIcon={<AddCircleOutline />}
                  onClick={() => handleOrderAdd(customer.Id)}
                  disabled={loading}
                  sx={{
                    bgcolor: modernTheme.accent,
                    textTransform: "none",
                    fontWeight: 600,
                    boxShadow: `0 4px 12px rgba(0, 167, 181, 0.3)`,
                    "&:hover": {
                      bgcolor: modernTheme.accentHover,
                      boxShadow: `0 6px 16px rgba(0, 167, 181, 0.4)`,
                      transform: "translateY(-1px)"
                    },
                    transition: "all 0.2s ease"
                  }}
                >
                  Sipariş Ekle
                </Button>
              </Box>
            )}
          </Paper>
        </Grid>
      </Grid>
    </Box>
    <Drawer
        open={isDrawerOpen}
        onClose={toggleDrawer}
        direction="right"
        className="custom-drawer"
        duration={120}
        zIndex={600}
      >
        <Box
          sx={{
            height: '100%',
            overflowY: 'auto',
            bgcolor: 'background.default',
            display: 'flex',
            flexDirection: 'column'
          }}
        >
          <Box
            sx={{
              p: 2.5,
              borderBottom: 1,
              borderColor: 'divider',
              bgcolor: 'background.paper',
              position: 'sticky',
              top: 0,
              zIndex: 1,
              boxShadow: '0 1px 3px rgba(0,0,0,0.05)'
            }}
          >
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
            >
              <Typography
                variant="h6"
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1.5,
                  fontWeight: 600,
                  color: 'text.secondary',
                  fontSize: '1rem'
                }}
              >
                {editingCustomer ? (
                  <FaUserPen style={{ fontSize: "20px", color: "rgba(0,0,0,0.54)" }} />
                ) : (
                  <FaUserPlus style={{ fontSize: "20px", color: "rgba(0,0,0,0.54)" }} />
                )}
                {editingCustomer ? "Müşteri Düzenle" : "Yeni Müşteri Ekle"}
              </Typography>
              <Box display="flex" gap={0.5}>
                <Button
                  type="submit"
                  form="musterikaydetform"
                  variant="text"
                  size="medium"
                  sx={{
                    minWidth: 'auto',
                    p: 1,
                    color: 'text.secondary',
                    '&:hover': {
                      bgcolor: 'action.hover',
                      color: 'text.primary'
                    }
                  }}
                >
                  <FaCheck style={{ fontSize: "18px" }} />
                </Button>
                <Button
                  variant="text"
                  size="medium"
                  onClick={toggleDrawer}
                  sx={{
                    minWidth: 'auto',
                    p: 1,
                    color: 'text.secondary',
                    '&:hover': {
                      bgcolor: 'action.hover',
                      color: 'text.primary'
                    }
                  }}
                >
                  <FaX style={{ fontSize: "18px" }} />
                </Button>
              </Box>
            </Box>
          </Box>
          <Box sx={{ flex: 1, p: 2.5, pt: 2 }}>
            <CustomerForm editingCustomer={editingCustomer} onCustomerCreated={handleCustomerCreated}/>
          </Box>
        </Box>
      </Drawer>
    </>
  );
};

export default CustomerDetails;